import { apiService } from './index';
import { IRegisterUser } from '../shared/types/auth';

export const asyncPostUser = async (formUser: IRegisterUser) => {
    return await apiService.post('/api/users', formUser);
};

export const asyncGetUsers = async (page?: number, pageSize?: number) => {
    return await apiService.get('/api/users', {
        limit: pageSize || 20,
        page: page || 0,
    });
};

export const asyncDeleteUser = async (id: string) => {
    return await apiService.delete(`/api/users/${id}`);
};

export const asyncGetUser = async (id: string | undefined) => {
    return await apiService.get(`/api/users/${id}`);
};

export const asyncPatchtUser = async (id: string, formUser: any) => {
    return await apiService.put(`/api/users/${id}`, formUser);
};
